/**
 * Add any functions related to date and time here.
 */


/**
 * Returns a timestamp representing a date that is `interval` days after (and not including) the given date.
 * @param date The base date. Can be a Date object or a date string.
 * @param interval The number of days to add (defaults to 1).
 * @returns The timestamp (in milliseconds) for the new date.
 */
export function getDateRightAfter(date, interval = 1) {
    return new Date(date).setDate(new Date(date).getDate() + interval);
}
